// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"522":"47226ec2","3239":"5487d179","3329":"5bd1be78","3884":"47226ec2","4679":"6c304171"}[chunkId] + ".chunk.css";
};